import { useState, useEffect } from "react"

const useMaxRows = ({ rowHeight = 54.5, offset = 300 }) => {
  const [rowCount, setRowCount] = useState(0)

  useEffect(() => {
    const calculateRows = () => {
      const availableHeight = window.innerHeight - offset
      const count = Math.floor(availableHeight / rowHeight)
      setRowCount(count > 0 ? count : 1)
    }

    calculateRows()

    window.addEventListener("resize", calculateRows)
    return () => window.removeEventListener("resize", calculateRows)
  }, [rowHeight, offset])

  return rowCount
}

export default useMaxRows
